import React from 'react';
import { api } from '../lib/api';
import { toast } from './ui/use-toast';
import { ArrowLeft, Check } from 'lucide-react';
import Button from "./ui/button";
import Input from "./ui/input";
import Label from "./ui/label";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "./ui/card";

// Función para validar cliente completo
function isClienteCompleto(cliente) {
  return cliente && cliente.nombre && cliente.apellido && cliente.vencimientoLicencia;
}

const DatosCliente = ({ cliente, setCliente, setPaso, setClienteId }) => {
  const handleChange = (e) => {
    setCliente({ ...cliente, [e.target.name]: e.target.value });
  };

  const guardarCliente = () => {
    if (!isClienteCompleto(cliente)) {
      toast({
        title: 'Error',
        description: 'La información del cliente está incompleta.',
        variant: 'destructive',
      });
      return;
    }

    api.post('/clientes', cliente)
      .then((response) => {
        setClienteId(response.data.id); // Asegúrate de que el cliente_id se establece aquí
        toast({
          title: 'Cliente guardado',
          description: 'Los datos del cliente se han guardado correctamente.',
        });
        setPaso(2);
      })
      .catch(() => {
        toast({
          title: 'Error',
          description: 'No se pudo guardar el cliente.',
          variant: 'destructive',
        });
      });
  };

  return (
    <Card className="shadow-md border border-gray-300 rounded-lg bg-white">
      <CardHeader className="bg-gray-100 py-4 px-6 rounded-t-lg">
        <CardTitle className="text-xl font-semibold text-gray-800">Datos del Cliente</CardTitle>
      </CardHeader>
      <CardContent className="px-6 py-4 space-y-4">
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <Label htmlFor="nombre" className="text-sm text-gray-700">Nombre</Label>
            <Input
              id="nombre"
              name="nombre"
              value={cliente.nombre}
              onChange={handleChange}
              required
              className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>
          <div>
            <Label htmlFor="apellido" className="text-sm text-gray-700">Apellido</Label>
            <Input
              id="apellido"
              name="apellido"
              value={cliente.apellido}
              onChange={handleChange}
              required
              className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <Label htmlFor="dni" className="text-sm text-gray-700">DNI</Label>
            <Input
              id="dni"
              name="dni"
              value={cliente.dni}
              onChange={handleChange}
              required
              className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>
          <div>
            <Label htmlFor="telefono1" className="text-sm text-gray-700">Teléfono</Label>
            <Input
              id="telefono1"
              name="telefono1"
              value={cliente.telefono1}
              onChange={handleChange}
              required
              className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
            />
          </div>
        </div>
        <div>
          <Label htmlFor="telefono2" className="text-sm text-gray-700">Teléfono Alternativo</Label>
          <Input
            id="telefono2"
            name="telefono2"
            value={cliente.telefono2}
            onChange={handleChange}
              className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>
        <div>
          <Label htmlFor="vencimientoLicencia" className="text-sm text-gray-700">Vencimiento Licencia</Label>
          <Input
            id="vencimientoLicencia"
            name="vencimientoLicencia"
            type="date"
            value={cliente.vencimientoLicencia}
            onChange={handleChange}
            required
            className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>
        <div>
          <Label htmlFor="observaciones" className="text-sm text-gray-700">Observaciones</Label>
          <Input
            id="observaciones"
            name="observaciones"
            value={cliente.observaciones}
            onChange={handleChange}
            className="mt-1 border-gray-300 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>
      </CardContent>
      <CardFooter className="flex justify-between px-6 py-4 bg-gray-100 rounded-b-lg">
        <Button
          onClick={() => setPaso(1)}
          variant="outline"
          className="text-gray-600 border-gray-400 hover:bg-gray-200"
        >
          <ArrowLeft className="mr-2 h-4 w-4" /> Anterior
        </Button>
        <Button
          onClick={guardarCliente}
          className="bg-blue-600 text-white hover:bg-blue-700"
        >
          Guardar <Check className="ml-2 h-4 w-4" />
        </Button>
      </CardFooter>
    </Card>
  );
};

export default DatosCliente;
